module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Bushman-Web-640.3c18e860.jpg";